module.exports = __webpack_public_path__ + "static/media/redFacebook.0ef8f308.svg";